import Book from './component'
export default Book
